export function assert_never(variable: never): never {
    return variable;
}
